import { Outlet, useNavigate } from 'react-router-dom';
import { Sidebar } from '../../Modules/Sidebar/Sidebar.jsx';
import { Spinner } from 'react-bootstrap';
import { Breadcrumbs } from '../../entities/Breadcrumbs/Breadcrumbs.jsx';
import { Suspense, useEffect } from 'react';
import { axiosInstance } from '../../shared/api/axiosInstance.js';
import { useStore } from '../../shared/stores/context.js';
import Cookies from 'js-cookie';
import { observer } from 'mobx-react-lite';
import { createPortal } from 'react-dom';
import { ToastContainer } from 'react-toastify';

const Layout = observer(({ children }) => {
  const { userStore } = useStore();
  const navigate = useNavigate();

  useEffect(() => {
    // const sid = Cookies.get("sid");
    // if (sid) {
    //   axiosInstance.defaults.headers = {
    //     Sessid: sid,
    //   };
    //   userStore.getData();
    // } else {
    //   navigate("/login");
    // }
  }, []);

  if (!userStore.isAuth) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <Spinner />
      </div>
    );
  }

  if (!userStore.isInitialization) return;

  return (
    <div className="container-fluid container-panel">
      <div className="row bg-light">
        <Sidebar />
        <div className="col-md-12 col-lg-9">
          <main>
            <Breadcrumbs />
            <div className="page">
              <Suspense fallback={<Spinner />}>
                <Outlet />
              </Suspense>
            </div>
          </main>
        </div>
      </div>
      {createPortal(<ToastContainer />, document.body)}
    </div>
  );
});

export default Layout;
